import React from "react";

class ReadMore extends React.Component {
  state = {
    isReadMore: true,
    showLess: false,
  };
  ReadMore = (content, len) => {
    const text = content;
    const toggleReadMore = () => {
      if (this.state.isReadMore === true) {
        this.setState({
          isReadMore: false,
          showLess: true,
        });
      } else {
        this.setState({
          isReadMore: true,
          showLess: false,
        });
      }
    };
    return (
      <div className="read-more-cards">
        {this.state.isReadMore ? text.slice(0, len) : text}
        <span onClick={toggleReadMore}>{this.state.isReadMore ? !!text && text !== "" && text.length > len ? <span className="read-more-link"> Read more</span> : <></> : this.state.showLess ? <span className="read-more-link"> Show less </span> : <></>}</span>
      </div>
    );
  };
  render() {
    return <div>{!!this && !!this.props && !!this.props.dataContent && this.props.dataContent !== "" ? <span className="bold-data">{this.ReadMore(this.props.dataContent, this.props.dataLength)}</span> : <></>}</div>;
  }
}
export default ReadMore;
